<app-navbar></app-navbar>

<div class="create-reservation-container">
    <div class="form-group cliente-busqueda">
        <h3>Asignar cliente a la reserva</h3>
        <div class="busqueda-opciones">
            <label for="clienteEmail">Email del cliente</label>
            <input id="clienteEmail" type="email" [(ngModel)]="clienteEmail" name="clienteEmail"
                placeholder="Email del cliente" />
            <label for="clienteDocumento">Número de documento</label>
            <input id="clienteDocumento" type="text" [(ngModel)]="clienteDocumento" name="clienteDocumento"
                placeholder="Número de documento" />
            <button type="button" (click)="buscarCliente()">Buscar cliente</button>
        </div>
        <div *ngIf="clienteBusquedaError" class="error-message">{{ clienteBusquedaError }}</div>
        <div *ngIf="clienteId">
            <span class="cliente-encontrado">Cliente encontrado: <strong>{{ clienteId }}</strong></span>
        </div>
    </div>

    <h2>Crear nueva reserva</h2>
    <form (ngSubmit)="crearReserva()" class="reservation-form">
        <div class="form-group">
            <label for="hotelId">Alojamiento</label>
            <select id="hotelId" [(ngModel)]="form.hotelId" name="hotelId" required
                (ngModelChange)="cargarHabitaciones($event)">
                <option value="" disabled selected>Selecciona un alojamiento</option>
                <option *ngFor="let alojamiento of alojamientos" [value]="alojamiento.id">{{ alojamiento.name ||
                    alojamiento.title }}</option>
            </select>
        </div>
        <div class="form-group">
            <label for="roomId">Habitación</label>
            <select id="roomId" [(ngModel)]="form.roomId" name="roomId" required
                (ngModelChange)="onHabitacionChange($event)">
                <option value="" disabled selected>Selecciona una habitación</option>
                <option *ngFor="let habitacion of habitaciones" [value]="habitacion.room_id">
                    {{ habitacion.type }} - Habitación {{ habitacion.number }} (Piso {{ habitacion.floor }}, Camas: {{
                    habitacion.beds }}, Baños: {{ habitacion.bathroom }})
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="checkInDate">Fecha de entrada</label>
            <input id="checkInDate" type="date" [(ngModel)]="form.checkInDate" name="checkInDate" required
                (change)="onFechaChange()" />
        </div>
        <div class="form-group">
            <label for="checkOutDate">Fecha de salida</label>
            <input id="checkOutDate" type="date" [(ngModel)]="form.checkOutDate" name="checkOutDate" required
                (change)="onFechaChange()" />
        </div>
        <div class="form-group">
            <label for="numAdults">Adultos</label>
            <input id="numAdults" type="number" min="1" [(ngModel)]="form.numAdults" name="numAdults" required
                (change)="onPersonasChange()" />
        </div>
        <div class="form-group">
            <label for="numChildren">Niños</label>
            <input id="numChildren" type="number" min="0" [(ngModel)]="form.numChildren" name="numChildren"
                (change)="onPersonasChange()" />
        </div>
        <div class="form-group">
            <label for="numInfants">Bebés</label>
            <input id="numInfants" type="number" min="0" [(ngModel)]="form.numInfants" name="numInfants"
                (change)="onPersonasChange()" />
        </div>
        
        
        <div class="form-group">
            <h3>Huéspedes</h3>
            <div class="guest-form">
                <input type="text" [(ngModel)]="huespedTemp.name" placeholder="Nombre" />
                <input type="text" [(ngModel)]="huespedTemp.lastName" placeholder="Apellido" />
                <select [(ngModel)]="huespedTemp.idType">
                    <option value="Cédula de Ciudadanía">Cédula de Ciudadanía</option>
                    <option value="Cédula de Extranjería">Cédula de Extranjería</option>
                    <option value="Pasaporte">Pasaporte</option>
                    <option value="Tarjeta de Identidad">Tarjeta de Identidad</option>
                </select>
                <input type="text" [(ngModel)]="huespedTemp.idNumber" placeholder="Número de documento" />
                <input type="text" [(ngModel)]="huespedTemp.phone" placeholder="Teléfono" />
                <input type="text" [(ngModel)]="huespedTemp.emergencyPhone" placeholder="Teléfono emergencia" />
                <button type="button" (click)="agregarHuesped()">Agregar huésped</button>
            </div>
            <div class="guest-list">
                <div *ngFor="let huesped of huespedes; let i = index" class="guest-item">
                    <span>{{ huesped.name }} {{ huesped.lastName }} - {{ huesped.idType }}: {{ huesped.idNumber }} -
                        Tel: {{
                        huesped.phone }}</span>
                    <button type="button" (click)="eliminarHuesped(i)">Eliminar</button>
                </div>
                <div *ngIf="huespedes.length === 0" class="no-guests">No hay huéspedes registrados.</div>
            </div>
        </div>
        <div class="form-group">
            <label>Costo habitación</label>
            <div class="room-cost">${{ form.roomCost }} x {{ noches }} noche(s) x {{ form.numAdults + form.numChildren +
                form.numInfants }} persona(s) = ${{ noches * form.roomCost * (form.numAdults + form.numChildren +
                form.numInfants || 1) }}</div>
        </div>
        <div class="form-group">
            <label>Servicios adicionales</label>
            <div class="additional-services-list">
                <div *ngFor="let servicio of serviciosAdicionales">
                    <label>
                        <input type="checkbox" [checked]="servicio.selected"
                            (change)="toggleServicioAdicional(servicio)" />
                        {{ servicio.service }} (+${{ servicio.cost }})
                    </label>
                </div>
                <div *ngIf="serviciosAdicionales.length === 0" class="no-services">No hay servicios adicionales
                    disponibles.</div>
            </div>
        </div>
        <div class="form-group">
            <label>Total</label>
            <div class="total-cost">${{ total }}</div>
        </div>
        <div class="form-group" *ngIf="mensajeHuespedes">
            <span class="guest-warning">{{ mensajeHuespedes }}</span>
        </div>
        <button type="submit" class="submit-btn" [disabled]="loading">{{ loading ? 'Creando...' : 'Crear reserva'
            }}</button>
    </form>
    <div *ngIf="error" class="error-message">{{ error }}</div>
    <div *ngIf="success" class="success-message">{{ success }}</div>
</div>